// src/components/Footer.js
import React from 'react';

const Footer = ({ isAuthenticated }) => {
    return (
        <footer className="footer mt-auto py-3 bg-light">
            <div className="container text-center">
                <span className="text-muted">© {new Date().getFullYear()} Event Plan</span>
                <span className="text-muted mx-2">|</span>
                <a href="https://t.me/eventplanru" target="_blank" rel="noopener noreferrer" className="text-muted">Telegram-канал</a>
                <span className="text-muted mx-2">|</span>
                <a href="https://pay.cloudtips.ru/p/32146f3c" target="_blank" rel="noopener noreferrer" className="text-muted">Поддержать проект</a>
            </div>
        </footer>
    );
};

export default Footer;
